export const checkPermission = (permissions, entity, action) => {
    // Check for 'All' permissions for cloud_service, cloud_sub_service, cloud_work, and cloud_resource

    if (permissions.cloud_service?.includes('All')) {
        return true
    }

    if (permissions.cloud_sub_service?.includes('All')) {
        return true
    }

    if (
        permissions.cloud_service?.includes('All') &&
        permissions.cloud_sub_service?.includes('All') &&
        permissions.cloud_work?.includes('All') &&
        permissions.cloud_resource?.includes('All')
    ) {
        return true; // Full permission for everything
    }

    // Check specific sub-service (e.g., Server, Disk, Networking)
    const subServiceIndex = permissions.cloud_sub_service?.indexOf(entity);

    // If the entity is found, check the corresponding cloud_work and cloud_resource permissions
    if (subServiceIndex !== -1) {
        const cloudWorkForEntity = permissions?.cloud_work[subServiceIndex];

        const cloudResourceForEntity = permissions?.cloud_resource[subServiceIndex];

        // Check if the user has the specific action (like 'Create', 'Start', etc.)
        if (cloudWorkForEntity.includes('All')) {
            return true;
        }
        return cloudWorkForEntity?.includes(action) || cloudResourceForEntity?.includes(action);
    }

    return false; // No permissions for this entity or action
};
